'use client';
import { jsx } from 'react/jsx-runtime';
import '@tanstack/react-query';
import { useState, useRef, useEffect, Suspense } from 'react';
import { loadStoryblokBridge } from '@storyblok/js';
import { S as StoryblokComponent } from './StoryblokComponent-server-DCJyvOF5.mjs';
import { u as useStoryblokContext } from './StoryblokProvider-shared-BsrrIAwo.mjs';

const ClientStoryblokStory = ({ story, bridgeLess, ...rest })=>{
    const { onPublished } = useStoryblokContext();
    const [blokState, setBlokState] = useState(story.content);
    const hasRanRef = useRef(false);
    useEffect(()=>{
        if (hasRanRef.current || bridgeLess) {
            return;
        }
        loadStoryblokBridge().then(()=>{
            const { StoryblokBridge } = window;
            const storyblokInstance = new StoryblokBridge();
            storyblokInstance.on([
                "change",
                "published"
            ], ()=>{
                onPublished == null ? void 0 : onPublished();
            });
            storyblokInstance.on([
                "input"
            ], (e)=>{
                var _e_story;
                setBlokState(e == null ? void 0 : (_e_story = e.story) == null ? void 0 : _e_story.content);
            });
            hasRanRef.current = true;
        });
    }, [
        bridgeLess
    ]);
    return /*#__PURE__*/ jsx(Suspense, {
        children: /*#__PURE__*/ jsx(StoryblokComponent, {
            ...rest,
            blok: blokState,
            preview: true
        })
    });
};

export { ClientStoryblokStory as C };
